/** Shared typography classes for shadcn/ui — aligned with Z-Cars design tokens. */
export const uiFontSans = "font-sans";
export const uiTextSm = "text-sm";
export const uiControl = `${uiFontSans} ${uiTextSm}`;
